import { useState } from "react";
import { connect } from "react-redux";
import { Fade, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";

import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";

import { GetDailyCronLogs } from "../../redux/dailyCronLog/actions";

import "./style.css";
import DCLDetails from "./components/DCLDetails";

function DailyCronLog(props) {
    const [showModal, setShowModal] = useState(false);
    const [selectedDCL, setSelectedDCL] = useState(null);

    const displayType = {
        "Notification": "daily-user-update-notification",
        "Email Reminder": "brg-patient-email-reminder",
    }

    return (
        <div className="main-container" id="daily-cron-log">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title={props?.displayType.toUpperCase()}
                        description=""
                        store={props.DailyCronLog}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "ID" },
                                { title: "Type" },
                                { title: "No. of Recipient" },
                                { title: "Date" },
                                { title: "" },
                            ],
                            body: (dcl, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{dcl?.id}</h5></td>
                                        <td><h5>{dcl?.type?.toUpperCase()}</h5></td>
                                        <td><h5>{dcl?.notified}</h5></td>
                                        <td><h5>{moment(dcl?.date).format("YYYY-MM-DD")}</h5></td>
                                        <td>
                                            <Tooltip title="Show Metadata" onClick={() => {
                                                setShowModal(true);
                                                setSelectedDCL(dcl);
                                            }}>
                                                <IconButton>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetDailyCronLogs(page, count, { ...filter, type: displayType[props?.displayType] }, sort);
                            },
                            // add: () => {
                            //     setShowModal(true);
                            // },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Metadata"}>
                <DCLDetails dcl={selectedDCL} />
            </CustomSliderModalV2>
        </div>
    );
}

const mapStateToProps = (state) => ({
    DailyCronLog: state.DailyCronLog
})

export default connect(mapStateToProps, {
    GetDailyCronLogs,
})(DailyCronLog);
